import { MetaInfo } from '@nexla/@types';
import { useGetPaging } from 'js/hooks/useGetPaging';

export const useGetMetaInfoByConnectorType = (connectorType: string) => {
  const { metaInfoById } = useGetPaging();
  const metaInfo = metaInfoById[connectorType];
  if (metaInfo) {
    return metaInfo as MetaInfo;
  }
  return null;
};
